import { useState, useEffect } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPortfolio = () => {
    const portfolioSection = document.getElementById('portfolio');
    portfolioSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Background Video/Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7f4893652642b909712a44994f94cc40.jpg"
          alt="Feel Music Performance"
          className="w-full h-full object-cover object-center opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center px-6">
        <div className={`text-center max-w-5xl transition-all duration-1500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {/* Logo/Brand */}
          <div className="mb-8">
            <h1 className="mb-6">
              <img
                src="https://static.readdy.ai/image/f3ee8701b883937bc520e8fddc6bcc4d/30ec09fe31c3706e0f87c3760b8f1b9e.png"
                alt="Feel Music"
                className="h-24 md:h-32 lg:h-40 mx-auto"
              />
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto"></div>
          </div>

          {/* Headline */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white mb-6 leading-tight tracking-wide">
            Criamos a Atmosfera,<br />Garantimos o Espetáculo
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto">
            Curadoria artística refinada com estrutura técnica de ponta para eventos corporativos e sociais de alto padrão
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button
              onClick={scrollToPortfolio}
              className="group relative px-10 py-5 bg-gradient-to-r from-amber-500 to-yellow-600 text-black font-bold text-lg rounded-full overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/50 whitespace-nowrap cursor-pointer"
            >
              <span className="relative z-10 flex items-center justify-center gap-3">
                Conheça nossos projetos
                <i className="ri-arrow-right-line text-xl"></i>
              </span>
            </button>

            <button
              onClick={scrollToContact}
              className="group px-10 py-5 bg-transparent border-2 border-white text-white font-bold text-lg rounded-full transition-all duration-300 hover:bg-white hover:text-black hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center justify-center gap-3">
                Solicitar Orçamento
                <i className="ri-mail-line text-xl"></i>
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-amber-500"></i>
      </div>
    </section>
  );
}
